import { render, staticRenderFns } from "./application-details.vue?vue&type=template&id=3193366d"
import script from "./application-details.vue?vue&type=script&lang=js"
export * from "./application-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports